import { HorizontalBar } from 'vue-chartjs';

export default {
  extends: HorizontalBar,
  props: ['data', 'options'],

  mounted() {
    this.renderChart(this.data, this.options);
  },
  watch: {
    async data() {
      this.renderChart(this.data, this.options);
    },
  },
};

// creates tooltips for labels to display full description for code
Chart.scaleService.updateScaleDefaults('category', {
  ticks: {
    callback(tick) {
      const characterLimit = 25;
      if (tick.length >= characterLimit) {
        return `${tick.slice(0, tick.length).substring(0, characterLimit - 1).trim()}...`;
      }
      return tick;
    },
  },
});
